export function getBillingFrequencyFormat(billingFrequency) {
  if (billingFrequency === "weekly") return "week";
  if (billingFrequency === "yearly") return "year";
  if (billingFrequency === "monthly") return "month";

  return "week";
}
